export default "__VITE_ASSET__DSaGLFfS__"